export type DropdownName = typeof DROPDOWN_NAME;
export type DropdownNameKey = keyof typeof DROPDOWN_NAME;
export const DROPDOWN_NAME = {
    'Category': 'Category',
    'sub_category_id': 'SubCategory',
    'TransportType': 'TransportType',
    'ReceiptCurrency': 'ReceiptCurrency',
    'TravelRefNo': 'TravelRefNo',
    'market_of_gift_recipient': 'market_of_gift_recipient',
    'Form': 'Form',
    'ProjectCode': 'ProjectCode',
    'AccommodationType': 'AccommodationType',
    'Country': 'Country',
    'Hotel': 'Hotel',
    'City': 'City',
    'DepartureCountry': 'DepartureCountry',
    'DepartureCity': 'DepartureCity',
    'ArrivalCountry': 'ArrivalCountry',
    'ArrivalCity': 'ArrivalCity',
    'Airline': 'Airline',
    'AddFlightLeg': 'AddFlightLeg',
    'AddDepartureCountry': 'AddDepartureCountry',
    'AddDepartureCity': 'AddDepartureCity',
    'AddArrivalCountry': 'AddArrivalCountry',
    'AddArrivalCity': 'AddArrivalCity',
    'AddAirline': 'AddAirline',
    'GiftCountry': 'GiftCountry',
    'PhoneType': 'PhoneType',
    'MedicalType': 'MedicalType',
    'CostCenter': 'CostCenter',
    'APEvent': 'APEvent',
    'APVendorCode': 'APVendorCode',
    'PDEntitlementLocation': 'PDEntitlementLocation',
    'PDEntitlementPercentage': 'PDEntitlementPercentage',
    'ClaimTemplate': 'ClaimTemplate',
    'APCostElement': 'APCostElement',
    'CashAdvanceType': 'CashAdvanceType',
    'VATBusinessPlace': 'VATBusinessPlace',
    'CCStatement': 'CCStatement',
    'ServiceOrder': 'ServiceOrder',
    'TripType': 'TripType',
    'WellnessType': 'WellnessType',
    'OtherDetailType': 'OtherDetailType',
    'ExpenseNatureType': 'ExpenseNatureType',
    'WBSProjectCode': 'WBSProjectCode',
    'CompanyAndBU': 'CompanyAndBU',
    'VendorCode': 'VendorCode',
    'EmployeeSelect': 'EmployeeSelect',
    'DoctorParticipant': 'DoctorParticipant',
    'DoctorAttendanceType': 'DoctorAttendanceType',
    'DetailType': 'DetailType',
    'Region': 'Region',
    'CountryArea': 'CountryArea',
    'OtherOperatingExpenseType': 'OtherOperatingExpenseType',  	// Hazel Amendments 20260113 #CHN-19146 - MM new category - Other oerating expense type 
} as const

export const DROPDOWN_API_URI_FORM_TEST: Record<DropdownName[DropdownNameKey], string> = {
    [DROPDOWN_NAME.Category]: '/api/GetSubCategory',
    [DROPDOWN_NAME.TransportType]: '/api/getTransportType',
    [DROPDOWN_NAME.sub_category_id]: '/api/GetSubCategory',
    [DROPDOWN_NAME.TravelRefNo]: '/api/getTravelRef',
    [DROPDOWN_NAME.market_of_gift_recipient]: '/api/getCountry',
    [DROPDOWN_NAME.ReceiptCurrency]: '/api/getCurrencyRate',
    [DROPDOWN_NAME.Form]: '/api/getAvailableForm',
    [DROPDOWN_NAME.ProjectCode]: '/api/getProject',
    [DROPDOWN_NAME.AccommodationType]: '/api/getAccommodationType',
    [DROPDOWN_NAME.Country]: '/api/getCountry',
    [DROPDOWN_NAME.Hotel]: '/api/getHotel',
    [DROPDOWN_NAME.City]: '/api/getCity',
    [DROPDOWN_NAME.DepartureCountry]: '/api/getCountry',
    [DROPDOWN_NAME.DepartureCity]: '/api/getCity',
    [DROPDOWN_NAME.ArrivalCountry]: '/api/getCountry',
    [DROPDOWN_NAME.ArrivalCity]: '/api/getCity',
    [DROPDOWN_NAME.Airline]: '/api/getAirline',
    [DROPDOWN_NAME.AddFlightLeg]: '/api/getCurrencyRate',   //Yes, No
    [DROPDOWN_NAME.AddDepartureCountry]: '/api/getCountry',
    [DROPDOWN_NAME.AddDepartureCity]: '/api/getCity',
    [DROPDOWN_NAME.AddArrivalCountry]: '/api/getCountry',
    [DROPDOWN_NAME.AddArrivalCity]: '/api/getCity',
    [DROPDOWN_NAME.AddAirline]: '/api/getAirline',
    [DROPDOWN_NAME.GiftCountry]: '/api/getCountry',
    [DROPDOWN_NAME.PhoneType]: '/api/getPhoneType',
    [DROPDOWN_NAME.MedicalType]: '/api/getMedicalType',
    [DROPDOWN_NAME.CostCenter]: '/api/getCostCenter',
    [DROPDOWN_NAME.APEvent]: '/api/getAPEvent',
    [DROPDOWN_NAME.APCostElement]: '/api/getCostElement',
    [DROPDOWN_NAME.APVendorCode]: '/api/getAnNPVendorCode',
    [DROPDOWN_NAME.PDEntitlementLocation]: '/api/GetPerDiemEntitlementLocation',
    [DROPDOWN_NAME.PDEntitlementPercentage]: '/api/GetPerDiemEntitlementPercentage',
    [DROPDOWN_NAME.ClaimTemplate]: '/api/getClaimTemplate',
    [DROPDOWN_NAME.CashAdvanceType]: '/api/getCashAdvanceType',
    [DROPDOWN_NAME.VATBusinessPlace]: '/api/getBusinessPlace',
    [DROPDOWN_NAME.CCStatement]: '/api/getCCStatement',
    [DROPDOWN_NAME.ServiceOrder]: '/api/getInternalOrder',
    [DROPDOWN_NAME.TripType]: '/api/getTripType',
    [DROPDOWN_NAME.WellnessType]: '/api/getWellnessType',
    [DROPDOWN_NAME.OtherDetailType]: '/api/getOtherType',
    [DROPDOWN_NAME.ExpenseNatureType]: '/api/getExpenseNatureType',
    [DROPDOWN_NAME.WBSProjectCode]: '/api/getWBSElement_Project_code',
    [DROPDOWN_NAME.CompanyAndBU]: '/api/getCompanyAndBU',
    [DROPDOWN_NAME.VendorCode]: '/api/getVendorCode',
    [DROPDOWN_NAME.EmployeeSelect]: '/api/employees',
    [DROPDOWN_NAME.DoctorParticipant]: '/api/doctors',
    [DROPDOWN_NAME.DoctorAttendanceType]: '/api/doctorAttendanceTypes',
    [DROPDOWN_NAME.DetailType]: '/api/getDetailType',
    [DROPDOWN_NAME.Region]: '/api/getRegion',
    [DROPDOWN_NAME.CountryArea]: '/api/getCountryArea',
    [DROPDOWN_NAME.OtherOperatingExpenseType]: '/api/getOtherOperatingExpenseType',  		// Hazel Amendments 20260113 #CHN-19146 - MM new category - Other oerating expense type 
};
